import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TableContainer from "../../../components/layout/table-container/table-container";
import TablePagination from "../../../components/Pagination/tablePagination";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loaderSpinningContainer";
import { useNavigate } from "react-router-dom";
import { trainingQaList } from "../../../redux/actions/ffTrainingAction";
import TrainingQaListTableData from "./training-qa-list-table-data";
import NumberPagination from "../../../components/Pagination/number-pagination";

const TrainingQaListTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [trainingQaListData, setTrainingQaListData] = useState([]);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [loading, setLoading] = useState(false);
  const [catchedErrorPopup, setCatchedErrorPopup] = useState(false);
  const [catchedErrorMsg, setCatchedErrorMsg] = useState();

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(trainingQaList({ search, page }, onSuccess, onError));
  }, [page, search]);

  const fetchtrainingQaList = () => {
    dispatch(trainingQaList({ search, page }, onSuccess, onError));
  };

  const onSuccess = (data) => {
    setLoading(false);
    setTrainingQaListData(data.data.data);
  };

  const closeCatchedErrPopup = () => {
    setCatchedErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    setCatchedErrorPopup(true);
    setCatchedErrorMsg(err.data.message);
  };

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <TableContainer>
        <thead>
          <tr className="table-rows color_747f9e">
            <th className="table-heads " width={"4%"}>
              #
            </th>
            <th className="table-heads " width={"12%"}>
              Q ID
            </th>
            <th className="table-heads " width={"15%"}>
              Question
            </th>
            <th className="table-heads " width={"15%"}>
              Video Url
            </th>
            <th className="table-heads " width={"12%"}>
              Chapter
            </th>
            <th className="table-heads " width={"10%"}>
              Priority
            </th>
            <th className="table-heads text-center" width={"22%"}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody style={{ position: "relative" }}>
          {loading === true ? (
            <div className="list-spinner-container">
              <LoadingSpinnerTable show={loading} />
            </div>
          ) : trainingQaListData?.ffTrainingQa?.length > 0 ? (
            <>
              {trainingQaListData?.ffTrainingQa?.map((eachRow, index) => (
                <TrainingQaListTableData
                  key={eachRow.id}
                  data={eachRow}
                  index={index}
                  fetchtrainingQaList={fetchtrainingQaList}
                  currentPage={trainingQaListData?.pagination?.currentPage}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="1" className="text-center no-data-container fs_16">
                <span>~ No Data Found ~</span>
              </td>
            </tr>
          )}
        </tbody>
      </TableContainer>
      {trainingQaListData?.pagination?.totalPages > 0 && (
        <NumberPagination
          setCurrentPage={setPage}
          pagination={trainingQaListData?.pagination?.currentPage}
          totalPages={trainingQaListData?.pagination?.totalPages}
          path={"/ff-training/qa"}
          filters={`${queryString}`}
        />
      )}
      <ErrorPopup
        show={catchedErrorPopup}
        title={catchedErrorMsg}
        handleClose={closeCatchedErrPopup}
      />
    </>
  );
};

export default TrainingQaListTable;
